import type { SrmProject } from '@types';

export interface ReportSaveScope {
    organizationId?: string;
    clientId?: string | null;
    assetId?: string;
    srmProjectId?: string;
    srmModuleId?: string;
    workflowId?: string;
}

export function reportSaveScope(report: any): ReportSaveScope {
    const scope: ReportSaveScope = {};
    for (const key of ['organizationId', 'clientId', 'assetId', 'srmProjectId', 'srmModuleId', 'workflowId'] as const)
        if (typeof report?.[key] === 'string' && report[key])
            scope[key] = report[key];
    if (!scope.workflowId && report?.reportType === 'GlobalThreatGroupAnalysis')
        scope.workflowId = 'threat_group_network_analysis';
    return scope;
}

export function reportSrmProjects(projects: SrmProject[], scope: ReportSaveScope): SrmProject[] {
    if (!scope.assetId && !scope.srmProjectId)
        return [];
    return projects.filter(project => project.organizationId === scope.organizationId
        && (!scope.clientId || project.clientId === scope.clientId)
        && (scope.assetId ? project.assetId === scope.assetId : project.id === scope.srmProjectId)
        && ['Draft', 'Architecting', 'Review', 'Active'].includes(project.status)
        && Array.isArray(project.modules));
}

export function reportSrmModules(project: SrmProject, scope: ReportSaveScope) {
    return project.modules.filter(module => scope.workflowId
        ? module.workflowId === scope.workflowId
        : module.id === scope.srmModuleId);
}
